import "../helpers/api_helper";
import axios from "axios";

export interface MerchantTriggerWebhookDto {
  serviceId?: string;
  triggerWebhookEnabled?: boolean | null;
  triggerWebhookUrl?: string | null;
  triggerWebhookConfigured?: boolean;
}

const base = () => axios.defaults.baseURL || "";

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem("accessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getTriggerWebhook(): Promise<MerchantTriggerWebhookDto> {
  return axios.get(`${base()}merchant/trigger-webhook`, {
    headers: { ...authHeaders() },
  }) as Promise<MerchantTriggerWebhookDto>;
}

export async function saveTriggerWebhook(body: {
  triggerWebhookUrl?: string;
  triggerWebhookEnabled: boolean;
}): Promise<MerchantTriggerWebhookDto> {
  return axios.put(`${base()}merchant/trigger-webhook`, body, {
    headers: { ...authHeaders(), "Content-Type": "application/json" },
  }) as Promise<MerchantTriggerWebhookDto>;
}
